import { useCloudinary } from 'providers/CloudinaryProvider/CloudinaryProvider'
import { useEffect, useMemo, useState } from 'react'
import { ReferenceImgProps } from 'screens/Schedule/PostPromptsSection/Types'
import { Delivery } from '@cloudinary/url-gen/actions'
import { fill } from '@cloudinary/url-gen/actions/resize'
import Styles from './ReferenceImage.module.scss'
import { LoadingShimmerer as BaseLoadingShimmerer } from 'components/LoadingShimmerer/LoadingShimmerer'
import cx from 'classnames'

export const LoadingShimmerer = () => <BaseLoadingShimmerer className={Styles.imageShimmer} />

export const ReferenceImg = ({ src, width, height, alt, ...props }: ReferenceImgProps) => {
  const cloudinary = useCloudinary()
  const [loading, setLoading] = useState(true)

  const referenceImgSrc = useMemo(() => {
    const img = cloudinary?.image(src.split('?')[0]).setDeliveryType('fetch')

    if (!img) return src

    return img.resize(fill().width(width).height(height)).delivery(Delivery.quality('auto')).toURL()
  }, [src, cloudinary, width, height])

  useEffect(() => {
    setLoading(true)
    const img = new Image()
    img.src = referenceImgSrc
    img.onload = () => {
      setLoading(false)
    }
    img.onerror = () => {
      setLoading(false)
    }
  }, [referenceImgSrc])

  return (
    <div className={Styles.image}>
      <img src={referenceImgSrc} {...props} alt={alt} className={cx({ [Styles.loading]: loading })} />
      {loading && <LoadingShimmerer />}
    </div>
  )
}
